/* @flow */

import React from 'react';
import { graphql } from 'react-apollo';
import type { QueryProps } from 'react-apollo';

import { EVENT_COUNT_LIMIT } from '../events-footer/index';
import upcomingEventsQuery from './upcoming.gql';
import UpcomingEvents from './layouts/upcoming';

type Props = {
  data: ProfileQuery & ProfileUpcomingEventsQuery & QueryProps
};
type State = {
  currentPage: number
};

const withGraphqlQuery = graphql(upcomingEventsQuery, {
  options: (props: Object) => {
    const userPath = props.match.params.userPath;

    return {
      variables: {
        slug: userPath.substring(userPath.lastIndexOf('-') + 1),
        limit: EVENT_COUNT_LIMIT,
        offset: 0
      }
    };
  },
  props: ({ data, ownProps }: Object): Props => {
    return {
      ...ownProps,
      data: {
        ...data,
        profile: ownProps.data.profile
      }
    };
  }
});

class UpcomingEventsContainer extends React.Component<void, Props, State> {
  state: State = { currentPage: 1 };

  render() {
    const { currentPage } = this.state;
    const newProps = {
      currentPage,
      changePage: this.changePage.bind(this),
      ...this.props
    };

    return <UpcomingEvents {...newProps} />;
  }

  changePage({ selected }: { selected: number }): void {
    this.props.data.fetchMore({
      variables: {
        limit: EVENT_COUNT_LIMIT,
        offset: EVENT_COUNT_LIMIT * selected
      },
      updateQuery: (prev, { fetchMoreResult }) => (fetchMoreResult ? fetchMoreResult : prev)
    });
    this.setState({ currentPage: selected + 1 });
  }
}

export default withGraphqlQuery(UpcomingEventsContainer);



// WEBPACK FOOTER //
// ./src/components/profile/events/upcoming.js